
export const buttonClassDefaults = `px-5 py-3`
export default {
  name: 'UiButton',
  /**
   * @type {import('@lovetoknow/ui-components-types').UiButtonProps
   */
  props: {
    roundedType: {
      type: String,
      required: false,
      default: 'pill',
    },
    color: {
      type: String,
      required: false,
      default: '',
    },
    outlined: {
      type: Boolean,
      required: false,
      default: false,
    },

    buttonClass: {
      type: String,
      required: false,
      default: buttonClassDefaults,
    },
  },
  data() {
    return {
      properties: ['roundedType', 'color', 'outlined', 'disabled'],
    }
  },
  computed: {
    buttonClasses() {
      const classes = []

      let color = ''
      let outlined = false

      for (const [propKey, propValue] of Object.entries(this.$props)) {
        // If the prop is a properties and it has a value
        if (this.properties.includes(propKey) && propValue) {
          if (propKey === 'outlined' && propValue) {
            outlined = true
          }

          if (propKey === 'color' && propValue) {
            color = propValue
          }

          if (propKey === 'roundedType' && propValue) {
            classes.push(`${propKey}-${propValue}`)
          }
        }
      }

      if (color && outlined) {
        classes.push(`button-outlined-${color}`)
      } else if (outlined) {
        classes.push('button-outlined')
      } else if (color) {
        classes.push(`button-${color}`)
      }

      return classes
    },
  },
  methods: {
    emitEvent() {
      this.$emit('customEvent')
    },
  },
}
